import React from 'react';

const ReplayIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 768">
			<path d="M707.85,384A28.87,28.87,0,0,0,679,410.18c-13.27,151.33-140.3,270-295.08,270C220.36,680.18,87.73,547.57,87.73,384S220.36,87.73,384,87.73c82.68,0,157,34.25,210.74,88.87l-78.06,0a29,29,0,0,0-29,29v1.15a29,29,0,0,0,29,29H665.38A29.64,29.64,0,0,0,695,206.21V57.48a29,29,0,0,0-29-29h-1.26a29,29,0,0,0-29,29v76.69C571.41,69.18,482.65,28.48,384,28.48,187.64,28.48,28.48,187.64,28.48,384S187.64,739.43,384,739.43c185.64,0,338-142.28,354.08-323.75A29.06,29.06,0,0,0,709.15,384Z" />
			<path d="M481.18,368.24,347.84,234.94A22.42,22.42,0,0,0,332,228.43a22.18,22.18,0,0,0-22.13,22.22V517.26A22.18,22.18,0,0,0,332,539.47a22.44,22.44,0,0,0,15.82-6.5l133.33-133.3A22.37,22.37,0,0,0,481.18,368.24Zm-112,59.65V340l44,43.95Z" />
		</svg>
	)
}

export default ReplayIcon;
